import React, { useState, useEffect, useRef, useMemo } from "react";
import Layout from "../pages/Layout";
import { useNavigate, useParams } from "react-router-dom";
import AddProductModal from "./AddProduct"; // Import the new component
import HomeIcon from "../assets/icons/home_icon";
import EditIcon from "../images/edit_icon";
import DeleteIcon from "../images/delete_icon";
import CheckIcon from "../assets/icons/check_icon";
import { Link } from "react-router-dom";
import axios from "axios";
import config from "../config";
import { toPng } from "html-to-image";
// import CustomerDetailPdf from "./Customer_pdf";
import jsPDF from 'jspdf'; // Make sure jsPDF is installed
import html2pdf from "html2pdf.js";
import html2canvas from 'html2canvas';
import ClipLoader from "react-spinners/ClipLoader";

import CustomerDetailPdf from "./Customer_pdf";
import ReactDOM from 'react-dom';
import { toast } from "react-toastify";


import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB"; // British format
import { confirmAlert, successAlert, errorAlert } from "../utils/swal";


registerLocale("en-GB", enGB);




const NewQuote = () => {
  const { quote_id } = useParams(); // Retrieve quote_id
  const [quoteNo, setQuoteNo] = useState("");
  const [product, setProduct] = useState("");
  const [isQuoteCreated, setIsQuoteCreated] = useState(quote_id);
  const [netPrice, setNetPrice] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isEmailLoading, setIsEmailLoading] = useState(false);


  const [totalPrice, setTotalPrice] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [weddingDate, setWeddingDate] = useState("");
  const [comments, setComments] = useState("");
  const [customer, setCustomer] = useState("");
  const [discount, setDiscount] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [quoteDate, setQuoteDate] = useState("");
  const [status, setStatus] = useState("Pending");
  const [newProduct, setNewProduct] = useState({
    style: "",
    quantity: "",
    fabric: "",
    lining: "",
    groomsman: false,
    price: 0,
    remarks: "",
    // customer_id: customer._id,
    quote_id: quote_id,
  });
  const [isAccepted, setIsAccepted] = useState(true);

  const calculatedTotal = useMemo(() => {
    return products.reduce((sum, item) => {
      const quantity = Number(item.quantity) || 1;
      const price = Number(item.price) || 0;
      return sum + quantity * price;
    }, 0);
  }, [products]);

  useEffect(() => {
    setNetPrice(calculatedTotal);
    // setTotalPrice(calculatedTotal);
  }, [calculatedTotal]);

  useEffect(() => {
    const np = Number(netPrice) || 0;
    let d = Number(discount) || 0;

    // clamp discount between 0 and netPrice
    if (d < 0) d = 0;
    if (d > np) d = np;

    const newTotal = Math.max(0, np - d);
    setTotalPrice(Number(newTotal.toFixed(2)));
  }, [netPrice, discount]);

  // const fetchQuoteDetails = async () => {
  //   setIsLoading(true);
  //   try {
  //     const response = await axios.get(
  //       `${config.BASE_URL}/api/v1/quoteDetail/${quote_id}`
  //     );
  //     const data = response.data.quoteDtail;
  //     const productData = response.data.productDetail;
  //     // console.log("productData",productData)
  //     // console.log("data",data)
  //     // const totalPrice = productData.reduce((sum, item) => sum + Number(item.price), 0);

  //     const netPrice = response.data.quoteDtail.netPrice;
  //     const discount1 = response.data.quoteDtail.discount
  //    if (data?.status == "Pending") {
  //      setIsAccepted(false)
  //    }
     
  //     setStatus(data?.status)

  //     setQuoteNo(data.quoteNo || "");
  //     setNetPrice(netPrice || "");
  //     // setTotalPrice(totalPrice || "");
  //     setDeliveryDate(data.deliveryDate || "");
  //     setWeddingDate(data.weddingDate || "");
  //     setComments(data.comments || "");
  //     setProducts(productData || []);
  //     setCustomer(data.customer_id);
  //     setQuoteDate(data.quoteDate);
  //     setDiscount(discount1)
  //     if (discount1) {
  //       const totalPrice = netPrice - Number(discount1)
  //       setTotalPrice(totalPrice)
  //     } else {
  //       const totalPrice = response.data.quoteDtail.totalPrice;
  //       setTotalPrice(totalPrice)
  //     }


  //   } catch (error) {
  //     console.error("Error fetching quote details:", error);
  //   }
  //   finally {
  //     setIsLoading(false); // hide loader
  //   }
  // };
 
  const fetchQuoteDetails = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${config.BASE_URL}/api/v1/quoteDetail/${quote_id}`
      );
      const data = response.data.quoteDtail;
      const productData = response.data.productDetail;

      if (data?.status == "Pending") {
        setIsAccepted(false);
      }
      
      setStatus(data?.status);
      setQuoteNo(data.quoteNo || "");
      setDeliveryDate(data.deliveryDate || "");
      setWeddingDate(data.weddingDate || "");
      setComments(data.comments || "");
      setCustomer(data.customer_id);
      setQuoteDate(data.quoteDate);
      
      // Sirf discount aur products set kariye. 
      // netPrice aur totalPrice aapke useMemo aur useEffect khud calculate kar lenge!
      setDiscount(data.discount || 0);
      setProducts(productData || []); 

    } catch (error) {
      console.error("Error fetching quote details:", error);
    } finally {
      setIsLoading(false); 
    }
  };

  useEffect(() => {
    if (!quote_id) return;
    const timer = setTimeout(() => {
      fetchQuoteDetails();
    }, 300); // Delay for smoother feel
    return () => clearTimeout(timer);
  }, [quote_id]);


  // console.log(quote_id)
  let customer_id = customer?._id;

  const handleSubmit = async () => {
    const quoteData = {
      customer_id,
      quoteNo,
      products,
      netPrice: parseFloat(netPrice),
      totalPrice: parseFloat(totalPrice),
      discount,
      deliveryDate,
      weddingDate,
      // quoteDate: new Date().toISOString().split("T")[0],
      quoteDate: quoteDate,
      comments,
      status: status,
    };

    try {
      const response = await axios.put(
        `${config.BASE_URL}/api/v1/editQuote/${quote_id}`,
        quoteData
      );
      if (response.status === 200) {
        toast.success("Quote successfully updated!");

      } else {
        toast.error("Failed to edit quote. Please try again.");
      }
    } catch (error) {
      console.error("Error creating quote:", error);
      toast.error("An error occurred while creating the quote.");
    }
  };

  // const handleSaveProduct = (product) => {
  //   if (!product || !product._id) return; // Skip if product is invalid

  //   setProducts((prevProducts) => {
  //     const existingIndex = prevProducts.findIndex(
  //       (p) => p._id === product._id
  //     );
  //     if (existingIndex >= 0) {
  //       const updatedProducts = [...prevProducts];
  //       updatedProducts[existingIndex] = { ...product };
  //       return updatedProducts;
  //     }
  //     return [...prevProducts, product];
  //   });

  //   handleModalClose();
  // };

  const handleSaveProduct = (product) => {
    if (!product || !product._id) return;

    const normalized = {
      ...product,
      price: Number(product.price) || 0,
      quantity: Number(product.quantity) || 1,
    };

    setProducts((prevProducts) => {
      const existingIndex = prevProducts.findIndex((p) => p._id === normalized._id);
      let newProducts;
      if (existingIndex >= 0) {
        newProducts = [...prevProducts];
        newProducts[existingIndex] = { ...normalized };
      } else {
        newProducts = [...prevProducts, normalized];
      }

      // Recalculate total immediately and update totalPrice
      const newTotal = newProducts.reduce((sum, it) => sum + (Number(it.price) || 0) * (Number(it.quantity) || 1), 0);
     
      setTotalPrice(newTotal);
      setNetPrice(newTotal); 

      
      return newProducts;
    });

    handleModalClose();
  };


  const handleModalClose = () => {
    setIsModalOpen(false);
    setNewProduct({
      style: "",
      quantity: 1,
      fabric: "",
      lining: "",
      groomsman: false,
      price: 0,
      remarks: "",
    });
  };

  const handleAddProductClick = () => {
    setIsModalOpen(true);
  };

  const navigate = useNavigate();


  // console.log(quote_id)
  // const handleCreateOrder = () => {
  //   // navigate(`/add-order/${customer_id}?total_price=${totalPrice}`);
  //   navigate(`/add-order/${customer_id}?total_price=${totalPrice}`, {
  //     state: {
  //       quote_id: quote_id,
  //       total_price: totalPrice,
  //       deliveryDate: deliveryDate,
  //       weddingDate: weddingDate

  //     },
  //   });

  // };

//   const handleCreateOrder = async () => {
//     // Basic validation
//     if (products.length === 0) {
//         toast.error("Please add at least one product before creating an order.");
//         return;
//     }

//     // const confirmCreate = await confirmAlert({
//     //     title: "Create Order?",
//     //     text: "Do you want to convert this Quote into an Order?",
//     //     confirmText: "Yes, Create",
//     //     cancelText: "No",
//     // });

//     // if (!confirmCreate) return;

//     setIsLoading(true); // Loader dikhane ke liye

//     const productIds = products.map(p => p._id);
    
//     // Default Dates (Aap chahein toh isse change kar sakte hain)
//     const today = new Date().toISOString().split("T")[0];
    
//     const orderData = {
//         customer_id: customer?._id,
//         order_no: `${quoteNo}`, // Quote No ke aage OR laga diya
//         price: totalPrice,
//         delivery_date: deliveryDate ? new Date(deliveryDate).toISOString().split("T")[0] : "",
//         wedding_date: weddingDate ? new Date(weddingDate).toISOString().split("T")[0] : "",
//         team_member: "", // Initial empty, edit page par fill hoga
//         product_ids: productIds,
//         quote_id: quote_id,
//         status: "To Place", // Initial status
//         location: "",
//         order_date: today,
//         delivery_priority:"Normal"
//     };

//     try {
//         const response = await axios.post(`${config.BASE_URL}/api/v1/addOrder`, orderData);
        
//         if (response.status === 201 || response.status === 200) {
//             const newOrderId = response.data.data._id; // Backend response check karein (data.data._id ya data._id)

//             // Optional: Discount sync
//             await axios.patch(`${config.BASE_URL}/api/v1/quote/update-discount/${quote_id}`, { 
//                 totalPrice, 
//                 discount, 
//                 weddingDate: orderData.wedding_date 
//             });

//             toast.success("Order Created Successfully!");
            
//             // 🚀 SEEDHA EDIT PAGE PAR NAVIGATION
//             navigate(`/edit-order/${newOrderId}`);
//         }
//     } catch (error) {
//         console.error("Error creating order from quote:", error);
//         toast.error(error?.response?.data?.message || "Failed to create order automatically.");
//     } finally {
//         setIsLoading(false);
//     }
// };

const handleCreateOrder = async () => {
    if (products.length === 0) {
        toast.error("Please add at least one product before creating an order.");
        return;
    }

    setIsLoading(true);

    try {
        // 1. Pehle current Quote ko save kar lo taaki latest products copy hon
        await handleSubmit(); 

        // 2. Naya Clone wala API call karo
        const response = await axios.post(`${config.BASE_URL}/api/convert/create-order-from-quote`, {
            quoteId: quote_id,
            delivery_priority: "Normal", // Default priority bhej do
            team_member: ""
        });
        
        if (response.status === 201 || response.status === 200) {
            const newOrderId = response.data.order._id; // Backend se naye order ki ID aayegi
            
            toast.success("Order Created Successfully with independent products!");
            
            // 3. SEEDHA EDIT ORDER PAGE PAR NAVIGATION
            navigate(`/edit-order/${newOrderId}`);
        }
    } catch (error) {
        console.error("Error creating order from quote:", error);
        toast.error(error?.response?.data?.message || "Failed to create order automatically.");
    } finally {
        setIsLoading(false);
    }
  };


  const productOptions = [
    { id: 1, style: "Suit" },
    { id: 2, style: "Jacket" },
    { id: 3, style: "Shirt" },
    { id: 4, style: "Pant" },
    { id: 5, style: "Tuxedo" },
    { id: 6, style: "Vest" },
    { id: 7, style: "Overcoat" },
    { id: 8, style: "Accessories" },
  ];

  const handleDeleteQuote = async (quoteId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this quote?"
    );
    if (!confirmDelete) return;

    try {
      const response = await axios.delete(
        `${config.BASE_URL}/api/v1/deleteQuote/${quoteId}`
      );

      if (response.status === 200) {
        toast.success("Quote deleted successfully.");
        navigate(`/customer-detail/${customer._id}`);
      } else {
        toast.error("Failed to delete the quote. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting quote:", error);
      toast.error("An error occurred while deleting the quote.");
    }
  };

  const handleDeleteProduct = async (productId) => {
    
    const confirmDelete = await confirmAlert({
  title: "Delete Product?",
  text: "This will permanently remove the product and cannot be undone.",
  confirmText: "Yes, delete it",
  cancelText: "Cancel",
});

    if (!confirmDelete) return;

    try {
      const response = await axios.delete(
        `${config.BASE_URL}/api/v1/deleteProduct/${productId}`
      );


      if (response.status === 200) {
        toast.success("Product deleted successfully.");

        // ✅ Update local products list
        setProducts((prevProducts) =>
          prevProducts.filter((product) => product._id !== productId)
        );

      } else {
        toast.error("Failed to delete the product. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error("An error occurred while deleting the product.");
    }
  };


  const handleEditProduct = async (product) => {
    setNewProduct(product);
    setIsModalOpen(true);
  };

  const handlePendingAcceptance = () => {
    setStatus("Accepted");
    setIsAccepted(true);
  };

  // const handleInvoiceClick = () => {
  //   navigate(`/new-invoice/${quote_id}?discount=${discount}`);
  // };

  const handleInvoiceClick = async () => {
    if (products.length === 0) {
        toast.error("Please add at least one product before creating an invoice.");
        return;
    }

    setIsLoading(true);

    try {
        // 1. Pehle current Quote ko save kar lo taaki latest products copy hon
        // await handleSubmit();

        // 2. Naya Clone wala API call karo
        const response = await axios.post(`${config.BASE_URL}/api/convert/create-invoice-from-quote`, {
            quoteId: quote_id
        });

        if (response.status === 201 || response.status === 200) {
            const newInvoiceId = response.data.invoice._id; // Backend se naye invoice ki ID aayegi
            
            toast.success("Invoice Created Successfully with independent products!");
            
            // 3. SEEDHA EDIT INVOICE PAGE PAR NAVIGATION
            // Note: Make sure aapka route '/edit-invoice/:id' properly defined ho App.js me
            navigate(`/edit-invoice/${newInvoiceId}`);
        }
    } catch (error) {
        console.error("Error creating invoice from quote:", error);
        toast.error(error?.response?.data?.error || "Failed to create invoice.");
    } finally {
        setIsLoading(false);
    }
  };


  const pdfRef = useRef(null);


  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return "";
    return d.toLocaleDateString("en-GB"); // dd/mm/yyyy
  };

 
 useEffect(() => {
    if (isModalOpen ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);


const handleEmail = async (customer) => {
  setIsEmailLoading(true);

  try {
    // 👉 1. Temp container
    const container = document.createElement("div");
    document.body.appendChild(container);

    // 👉 2. Prepare items
    const items = products.map((product) => ({
      description: `${product.description} - ${
        product?.groomsman == "true" ? "Groomsman " : ""
      }${product.fabric} ${product.lining}`,
      quantity: Number(product.quantity) || 1,
      price: Number(product?.price) || 0,
      amount:
        (Number(product.quantity) || 1) *
        (Number(product?.price) || 0),
    }));

    // 👉 3. Prepare data
    const updatedCustomer = {
      ...customer,
      date: quoteDate,
      quoteNumber: quoteNo,
      items,
      netPrice,
      totalAmount: totalPrice,
      discount,
      comments,
    };

    // 👉 4. Render component
    const root = ReactDOM.createRoot(container);
    root.render(<CustomerDetailPdf customer={updatedCustomer} />);

    // 👉 wait for render
    await new Promise((resolve) => setTimeout(resolve, 500));

    const element = container.querySelector(".customer_pdf");

    // 👉 5. Canvas
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/jpeg", 1.0);

    const pdf = new jsPDF("portrait", "mm", "a4");

    const pageWidth = 210;
    const pageHeight = 297;

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let finalWidth = imgWidth;
    let finalHeight = imgHeight;

    // 👉 AUTO SCALE (IMPORTANT 🔥)
    if (imgHeight > pageHeight) {
      const scale = pageHeight / imgHeight;
      finalWidth = imgWidth * scale;
      finalHeight = imgHeight * scale;
    }

    // 👉 center
    const xOffset = (pageWidth - finalWidth) / 2;
    const yOffset = (pageHeight - finalHeight) / 2;

    pdf.addImage(imgData, "JPEG", xOffset, yOffset, finalWidth, finalHeight);

    // 👉 convert to blob (EMAIL USE)
    const pdfBlob = pdf.output("blob");

    // 👉 cleanup
    root.unmount();
    document.body.removeChild(container);

    // 👉 filename
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-${today.getFullYear()}`;

    const clientName = (customer.customer_name || "Customer").replace(/\s+/g, "_");
    const fileName = `Quote_${clientName}_${formattedDate}.pdf`;

    // 👉 send API
    const formData = new FormData();
    formData.append("name", customer.customer_name);
    formData.append("email", customer.email);
    formData.append("subject", quote_id);
    formData.append("title", fileName);
    formData.append("pdf", pdfBlob, fileName);
    formData.append("type", "quote");

    const response = await axios.post(
      `${config.BASE_URL}/api/v1/sendEmail`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200) {
      toast.success("Email sent successfully!");
    } else {
      toast.error("Failed to send email.");
    }

  } catch (error) {
    console.error("Error sending email:", error);
    toast.error("Error sending email.");
  } finally {
    setIsEmailLoading(false);
  }
};


// working two page layout 
// const handleGeneratePdf = async (customer) => {
//   try {
//     // 👉 1. Temporary container create
//     const container = document.createElement("div");
//     document.body.appendChild(container);

//     // 👉 2. Prepare items
//     const items = products.map((product) => ({
//       description: `${product.description} - ${
//         product?.groomsman == "true" ? "Groomsman " : ""
//       }${product.fabric} ${product.lining}`,
//       quantity: Number(product.quantity) || 1,
//       price: Number(product.price) || 0,
//       amount:
//         (Number(product.quantity) || 1) *
//         (Number(product.price) || 0),
//     }));

//     // 👉 3. Prepare full customer object
//     const updatedCustomer = {
//       ...customer,
//       date: quoteDate,
//       quoteNumber: quoteNo,
//       items: items,
//       netPrice: netPrice,
//       totalAmount: totalPrice,
//       discount: discount,
//       comments: comments,
//     };

//     // 👉 4. Render React component
//     const root = ReactDOM.createRoot(container);
//     root.render(<CustomerDetailPdf customer={updatedCustomer} />);

//     // 👉 Wait for DOM render (important ⚠️)
//     await new Promise((resolve) => setTimeout(resolve, 500));

//     const element = container.querySelector(".customer_pdf");

//     // 👉 5. PDF options
//     const opt = {
//       margin: [10, 10, 10, 10],
//       filename: `Quote_${(customer.customer_name || "Customer").replace(/\s+/g, "_")}_${new Date()
//         .toLocaleDateString("en-GB")
//         .replace(/\//g, "-")}.pdf`,

//       image: { type: "jpeg", quality: 0.98 },

//       html2canvas: {
//         scale: 2,
//         useCORS: true,
//       },

//       jsPDF: {
//         unit: "mm",
//         format: "a4",
//         orientation: "portrait",
//       },

//       pagebreak: {
//         mode: ["avoid-all", "css", "legacy"],
//       },
//     };

//     // 👉 6. Generate PDF (multi-page automatic)
//     await html2pdf().set(opt).from(element).save();

//     // 👉 7. Cleanup
//     root.unmount();
//     document.body.removeChild(container);

//   } catch (error) {
//     console.error("PDF generation error:", error);
//   }
// };

const handleGeneratePdf = async (customer) => {
  try {
    // 👉 1. Temp container
    const container = document.createElement("div");
    document.body.appendChild(container);

    // 👉 2. Prepare items
    const items = products.map((product) => ({
      description: `${product.description} - ${
        product?.groomsman == "true" ? "Groomsman " : ""
      }${product.fabric} ${product.lining}`,
      quantity: Number(product.quantity) || 1,
      price: Number(product.price) || 0,
      amount:
        (Number(product.quantity) || 1) *
        (Number(product.price) || 0),
    }));

    // 👉 3. Prepare data
    const updatedCustomer = {
      ...customer,
      date: quoteDate,
      quoteNumber: quoteNo,
      items,
      netPrice,
      totalAmount: totalPrice,
      discount,
      comments,
    };

    // 👉 4. Render component
    const root = ReactDOM.createRoot(container);
    root.render(<CustomerDetailPdf customer={updatedCustomer} />);

    // 👉 Wait for render
    await new Promise((resolve) => setTimeout(resolve, 500));

    const element = container.querySelector(".customer_pdf");

    // 👉 5. Canvas
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/jpeg", 1.0);

    const pdf = new jsPDF("portrait", "mm", "a4");

    const pageWidth = 210; // A4 width mm
    const pageHeight = 297; // A4 height mm

    // 👉 original image size
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let finalWidth = imgWidth;
    let finalHeight = imgHeight;

    // 👉 6. SCALE DOWN if overflow
    if (imgHeight > pageHeight) {
      const scale = pageHeight / imgHeight;
      finalWidth = imgWidth * scale;
      finalHeight = imgHeight * scale;
    }

    // 👉 center content
    const xOffset = (pageWidth - finalWidth) / 2;
    const yOffset = (pageHeight - finalHeight) / 2;

    pdf.addImage(imgData, "JPEG", xOffset, yOffset, finalWidth, finalHeight);

    // 👉 filename
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-${today.getFullYear()}`;

    const clientName = (customer.customer_name || "Customer").replace(/\s+/g, "_");

    pdf.save(`Quote_${clientName}_${formattedDate}.pdf`);

    // 👉 cleanup
    root.unmount();
    document.body.removeChild(container);

  } catch (error) {
    console.error("Single page PDF error:", error);
  }
};
if (isLoading) {
  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", alignItems:"center", height:"100vh" }}>
      <ClipLoader size={25} color="#081042" />
    </div>
  );
}
  return (
    <Layout>
      <div className="new-quote-page">
          <header className="header">
            <h1>EDIT QUOTE</h1>
            <p>
              <Link to="/" className="home-link">
                {" "}
                <HomeIcon />{" "}
              </Link>{" "}
              / Customers / Edit Quote
            </p>
          </header>
          <h2 className="quote_customer_title">
            Customer{" "}
            <span className="quote_customer_name">{customer?.customer_name}</span>
          </h2>
          <div className="page_card_body">
            <form className="quote-form">
              <div className="quote_form_header">
                <div className="quote_number">
                  <label>Quote No</label>
                  <input
                    type="text"
                    value={quoteNo}
                    onChange={(e) => setQuoteNo(e.target.value)}
                    placeholder="Quote No"
                  />
                </div>
                <div className="quote_invoice_btn">
                  <button className="btn" onClick={handleInvoiceClick}>
                    Invoice
                  </button>
                </div>
                <div className="quote_date">
                  <input
                    type="date"
                    value={
                      quoteDate
                        ? new Date(quoteDate).toISOString().split("T")[0]
                        : ""
                    }
                    onChange={(e) => setQuoteDate(e.target.value)}
                  />
                </div>
              </div>

              <div className="select_product_and_date">
                <div className="select_product">
                  <label>Select Product</label>
                  <button
                    type="button"
                    onClick={handleAddProductClick}
                    className="add-product-btn"
                  >
                    {" "}
                    Add Product{" "}
                  </button>
                </div>
                <div className="select_date">
                  <div className="form-group">
                    <label>Delivery Date</label>
                    <ReactDatePicker
                      selected={deliveryDate}
                      onChange={(date) => setDeliveryDate(date)}
                      dateFormat="dd/MM/yyyy"
                      locale="en-GB"
                      className="date-picker"
                      placeholderText="Select delivery date"
                    />
                  </div>
                  <div className="form-group">
                    <label>Wedding Date</label>
                    <ReactDatePicker
                      selected={weddingDate}
                      onChange={(date) => setWeddingDate(date)}
                      dateFormat="dd/MM/yyyy"
                      locale="en-GB"
                      className="date-picker"
                      placeholderText="Select wedding date"
                    />
                  </div>
                </div>

              </div>

              {products.map((product, index) => (
                <div className="edit_quote_product">
                  <div className="edit_quote_header">
                    <div className="input_product">
                      <input
                        type="text"
                        name=""
                        id="product_name"
                        value={product?.description}
                        onChange={() => { }}
                      />
                    </div>
                    <div className="edit_delete_btns">
                      <button
                        className="edit_details"
                        onClick={(e) => {
                          e.preventDefault();
                          handleEditProduct(product);
                        }}
                      >
                        <EditIcon />
                      </button>
                      <button
                        type="button"
                        className="remove_product"
                        onClick={() => handleDeleteProduct(product._id)}
                      >
                        <DeleteIcon />
                      </button>

                    </div>
                  </div>
                  <div className="edit_quote_product_detils">
                    <div className="left">
                      <div class="form-group row">
                        <label class="field_label">Quantity</label>
                        <div class="field_value">
                          <input type="number" value={product?.quantity} onChange={() => { }} />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="field_label">Fabric</label>
                        <div class="field_value">
                          <input type="text" value={product?.fabric} onChange={() => { }} />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="field_label">Lining</label>
                        <div class="field_value">
                          <input type="text" value={product?.lining} onChange={() => { }} />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="field_label">Groomsman</label>
                        <div className="input_field">
                          <input
                            type="checkbox"
                            checked={product?.groomsman == "true" || false}
                          />
                          <span className="checked_icon">
                            <CheckIcon />
                          </span>
                          <p>Yes</p>
                        </div>
                      </div>
                    </div>
                    <div className="right">
                      <div class="form-group row">
                        <label class="field_label">Price</label>
                        <div class="field_value">
                          <input type="number" value={product?.price} onChange={() => { }} />
                        </div>
                      </div>
                      <div class="form-group textarea">
                        <label class="field_label">Remarks</label>
                        <div class="field_value">
                          <textarea
                            type="text"
                            value={product?.remarks}
                            onChange={() => { }}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              <div className="quote_pricing">
                <h4>Price</h4>
                <div className="quote_pricing_fields">
                  <div className="form-group">
                    <label>Net Price $</label>
                    <input
                      type="number"
                      value={netPrice}
                      // onChange={(e) => setNetPrice(e.target.value)}
                      placeholder="Net Price"
                    />
                  </div>

                  <div className="form-group total-price">
                    <label>Total $</label>
                    <input
                      type="number"
                      value={totalPrice}
                      // onChange={(e) => setTotalPrice(e.target.value)}
                      placeholder="Total Price"
                    />
                  </div>
                </div>


                <div className="form-group">
                  <label>Discount $</label>
                  <input
                    type="text"
                    value={discount}
                    onChange={(e) => {
                      const raw = Number(e.target.value) || 0;
                      const np = Number(netPrice) || 0;
                      const clamped = Math.max(0, Math.min(raw, np));
                      setDiscount(Number(clamped.toFixed(2)));
                      setTotalPrice(Number((np - clamped).toFixed(2)));
                    }}
                    placeholder="Discount"
                  />
                </div>


              </div>

              <div className="quote_comment">
                <div className="form-group">
                  <label>Comments</label>
                  <textarea
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    placeholder="Comments"
                  />
                </div>
                <button
                  type="button"
                  onClick={handlePendingAcceptance}
                  className="btn"
                  disabled={isAccepted}
                >
                  {isAccepted ? "Quote Accepted" : "Pending Acceptance"}
                </button>
              </div>

              <div className="new_quote_btns">
                <button type="button" onClick={handleSubmit} className="btn">
                  Save
                </button>
                {/* <CustomerDetailPdf ref={pdfRef} /> */}
                <button type="button" className="btn" onClick={() => handleGeneratePdf(customer)}>
                  Generate PDF
                </button>
                <button
                  onClick={() => handleEmail(customer)}
                  type="button"
                  className="btn"
                  disabled={isEmailLoading}
                >
                  {isEmailLoading ? (
                    <>
                      <ClipLoader color="#fff" size={18} /> Sending...
                    </>
                  ) : (
                    "Email Quote"
                  )}
                </button>

                <button type="button" onClick={handleCreateOrder} className="btn">
                  Create Order
                </button>
                {/* <button
                  type="button"
                  className="btn delete_btn"
                  onClick={() => handleDeleteQuote(quote_id)}
                >
                  Delete Quote
                </button> */}
              </div>
            </form>
          </div>

          <AddProductModal
            isModalOpen={isModalOpen}
            quote_id={quote_id}
            newProduct={newProduct}
            setNewProduct={setNewProduct}
            handleSaveProduct={handleSaveProduct}
            handleModalClose={handleModalClose}
            productOptions={productOptions}
            isOrder={false}
            fetchQuoteDetails={fetchQuoteDetails}
            customer_id={customer_id}
            quoteNo={quoteNo}
            setIsQuoteCreated={setIsQuoteCreated}
            isQuoteCreated={isQuoteCreated}
            addOrderForSuit={false}
          />
        </div>
     
    </Layout>
  );
};

export default NewQuote;
